import { useIntl } from 'gatsby-plugin-intl'

const useTranslation = id => {
  const intl = useIntl()

  return intl.formatMessage({ id })
}

export default useTranslation
